import _slicedToArray from "/builds/hooxitech/polgozar-front-end/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
var useUpdate = function useUpdate() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    setState = _useState2[1];
  return useCallback(function () {
    return setState({});
  }, []);
};
export default useUpdate;